import { Switch, Route, Redirect, NavLink } from 'react-router-dom'

import { useFlags } from 'flags'

import TCIOrganizations from './TCIOrganizations'
import TCIOrganizationUsers from './TCIOrganizationUsers'

const TCIRoutes: React.FC = () => {
  const { transcosmosDashboardAccess } = useFlags()

  if (!transcosmosDashboardAccess) {
    if (typeof transcosmosDashboardAccess === 'boolean') {
      return <Redirect to="/" />
    }

    return null
  }

  return (
    <>
      <div style={{ marginBottom: '10px', padding: '20px' }}>
        <NavLink className="tci-nav-link" to="/">
          Builder
        </NavLink>
        {` • `}
        <NavLink className="tci-nav-link" to="/tci/organizations">
          TCI Dashboard
        </NavLink>
      </div>
      <Switch>
        <Route exact path="/tci/organizations" component={TCIOrganizations} />
        <Route
          exact
          path="/tci/organizations/:orgId"
          component={TCIOrganizationUsers}
        />
      </Switch>
    </>
  )
}

export default TCIRoutes
